import React, { useState } from 'react'
import ModalButton from '../BarrierErrorModal/ModalButton'
import WarningGreenSvg from '../../../assets/icons/WarningGreenSvg'
import { FormGroup, Input } from 'reactstrap'
import axios from 'axios'

const acceptList = [
  {
    id: 0,
    text: 'Tanımladığım misafir(ler)in hobi bahçesi kullanım alanı içerisinde gerçekleştirdiği her türlü olumsuz davranıştan 1.derecede sorumlu olduğumu kabul ediyorum.',
  },
  {
    id: 1,
    text: 'Tanımladığım misafir(ler)in hobi bahçesi tahsis ve kullanım sözleşmesinde yer alan adli ve ahlaki şartları sağladığını kabul ve beyan ediyorum.',
  },
  {
    id: 2,
    text: 'Tanımladığım misafir(ler)den kaynaklı oluşacak olumsuz bir durumda hobi bahçesi tahsis ve kullanım sözleşmemin idare tarafından tek taraflı olarak fesih edilebileceğini ve hiçbir hak talep edemeyeceğimi kabul ediyorum.',
  },
  {
    id: 3,
    text: 'Yetkilendirme işlemi sonucunda gönderilecek kısa mesajda yer alan işlem bağlantısı yetkilendirme yapılan gün içerisinde geçerlidir.',
  },
]

const GuestRulesModal = ({ formData, toggle, dispatch }) => {
  const [checkbox, setCheckbox] = useState({
    checkbox1: false,
    checkbox2: false,
    checkbox3: false,
    checkbox4: false,
  })

  const handleCheck = (e) => {
    const value = e.target.value

    switch (value) {
      case '0':
        return setCheckbox({ ...checkbox, checkbox1: !checkbox.checkbox1 })
      case '1':
        return setCheckbox({ ...checkbox, checkbox2: !checkbox.checkbox2 })
      case '2':
        return setCheckbox({ ...checkbox, checkbox3: !checkbox.checkbox3 })
      case '3':
        return setCheckbox({ ...checkbox, checkbox4: !checkbox.checkbox4 })
      default:
        return false
    }
  }

  const areAllChecked = () => {
    return Object.values(checkbox).every((value) => value === true)
  }

  const _handleSubmit = () => {
    if (areAllChecked()) {
      dispatch({ type: 'SET_LOADING', value: true })
      axios
        .post('https://app.yanibasimdakaratay.com/api/hobi-bahce/misafir', formData, {
          headers: {
            Authorization: JSON.parse(localStorage.getItem('token')),
          },
        })
        .then((res) => {
          toggle()
          dispatch({ type: 'SET_LOADING', value: false })
          dispatch({ type: 'SET_FIELD', field: 'adi', value: '' })
          dispatch({ type: 'SET_FIELD', field: 'soyadi', value: '' })
          dispatch({ type: 'SET_FIELD', field: 'tel', value: '' })
          dispatch({ type: 'SET_FIELD', field: 'dogumTarihi', value: '' })
          dispatch({ type: 'SET_FIELD', field: 'tc', value: '' })
          dispatch({ type: 'SET_FIELD', field: 'plaka', value: '' })
          dispatch({ type: 'SET_FIELD', field: 'selectedCount', value: 'Kisi Sayısı Seçiniz...' })
          dispatch({ type: 'SET_MODAL', field: 'openSuccessModal', value: true })
        })
        .catch((err) => {
          if (err.response && err.response.status === 400) {
            alert(err.response.data.message)
          } else {
            alert(JSON.stringify(err))
          }
        }).finally(() => {
          dispatch({ type: 'SET_LOADING', value: false })
        })
    }
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: '.8rem',
        padding: '.6rem 0 0 0',
      }}
    >
      <WarningGreenSvg width={'4rem'} />
      <div
        style={{
          fontSize: '16px',
          fontWeight: '700',
        }}
      >
        Misafir Tanımlama Kuralları
      </div>
      <div style={{}}>
        {acceptList?.map((item) => (
          <FormGroup
            check
            key={item.id}
            className='formGroupCheckbox'
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'start',
              justifyContent: 'start',
              textAlign: 'start',
              gap: '.8rem',
              backgroundColor: checkbox[`checkbox${item.id + 1}`] ? '#c8e6cf' : 'transparent',
              borderRadius: '8px',
              fontWeight: '300',
            }}
          >
            <label className='checkboxLabel'>
              <Input type='checkbox' value={item.id} onChange={(e) => handleCheck(e)} />
              <span>{item.text}</span>
            </label>
          </FormGroup>
        ))}
      </div>
      <ModalButton
        disabled={!areAllChecked()}
        backgroundColor={'#205c42'}
        text={'Yetkilendirmeyi Onayla'}
        onClick={_handleSubmit}
      />
    </div>
  )
}

export default GuestRulesModal
